import React from 'react'

const HomeRunProfitabilityAccordion = ({ accordion, isActive, changeActiveAccordion }) => {
  const handleClick = () => {
    changeActiveAccordion(accordion)
  }

  return (
    <li
      className={
        isActive
          ? 'dealmed-home-run__item dealmed-home-run__item--active'
          : 'dealmed-home-run__item'
      }
    >
      <button
        className={
          isActive
            ? 'dealmed-home-run__button dealmed-home-run__button--active'
            : 'dealmed-home-run__button'
        }
        type="button"
        onClick={handleClick}
      >
        <p className="dealmed-home-run__title">{accordion.accordionTitle}</p>
      </button>
      <div
        className={
          isActive
            ? 'dealmed-home-run__content dealmed-home-run__content--active'
            : 'dealmed-home-run__content'
        }
      >
        <p className="dealmed-home-run__text">{accordion.accordionText}</p>
      </div>
    </li>
  )
}

export default HomeRunProfitabilityAccordion
